@keyframes checked-icon-animation {
    from {
        transform: scale(0);
    }

    to {
        transform: scale(1);
    }
}

.checkbox {
    position: relative;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    flex-direction: row;
    user-select: none;
    padding: 0;
    gap: 0.5rem;

    &.disabled {
        pointer-events: none;

        .checkbox-icon {
            opacity: var(--disabled-opacity);
        }
    }

    .checkbox-icon {
        border: 2px solid var(--checkbox-unchecked-color);
        border-radius: 0.25rem;
        width: 1rem;
        height: 1rem;
        box-sizing: content-box;
        color: var(--checkbox-unchecked-color);
        opacity: 1;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 auto;

        span {
            position: absolute;
            display: block;
            font-size: 1rem !important;
            font-weight: bold;
            animation-name: checked-icon-animation;
            animation-duration: 0.1s;
            animation-fill-mode: forwards;
            animation-timing-function: ease-out;
        }

        &.checked {
            border: 2px solid var(--cs-origin);
            color: var(--cs-origin);
        }
    }

    & > input {
        opacity: 0;
        position: absolute;
    }

    & > input:focus ~ .checkbox-icon {
        outline-offset: 1px;
        outline: 1px solid var(--checkbox-unchecked-color);
        border-radius: 0.25rem;

        &.checked {
            outline: 1px solid var(--cs-light);
        }
    }
}

.label {
    margin-left: 4px;
}